import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Youtube = props => {
  return (
    <SvgIcon {...props} viewBox='0 0 31 22'>
      <path d='M29.4105 3.80451C29.0655 2.51751 28.053 1.50201 26.7675 1.15551C24.4185 0.510511 15.021 0.500011 15.021 0.500011C15.021 0.500011 5.625 0.489511 3.2745 1.10601C2.0145 1.44951 0.973502 2.48751 0.625502 3.77301C0.00600247 6.12201 2.19772e-06 10.994 2.19772e-06 10.994C2.19772e-06 10.994 -0.00599778 15.89 0.609002 18.215C0.954002 19.5005 1.9665 20.516 3.2535 20.8625C5.6265 21.5075 14.9985 21.518 14.9985 21.518C14.9985 21.518 24.396 21.5285 26.745 20.9135C28.029 20.5685 29.046 19.5545 29.3955 18.269C30.0165 15.9215 30.021 11.051 30.021 11.051C30.021 11.051 30.051 6.15351 29.4105 3.80451ZM12.015 15.5075L12.0225 6.50751L19.833 11.015L12.015 15.5075Z' />
    </SvgIcon>
  );
};

export default Youtube;
